import { Box, Text } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { Dropdown } from '../Dropdown';
import { LocationCaption } from './LocationCaption';
import { LocationMap } from './LocationMap';
import { distanceBetweenGoogleLatLong } from './LocationUtils';
import { useGlobalState } from 'store/reducers/reducer';
import { getGeocode } from 'store/sagas/sagas';
export const LocationDropdowns = ({ idAddressStr, ipAddressStr, ipGeocode, crossCheckIpDistance }) => {
    const { asyncDispatch } = useGlobalState();
    const [idGeocode, setIdGeocode] = useState(undefined);
    const [distanceBetweenStr, setDistanceBetweenStr] = useState(undefined);
    useEffect(() => {
        if (!idAddressStr) {
            return;
        }
        asyncDispatch(getGeocode(idAddressStr)).then((response) => {
            if (!response) {
                return;
            }
            setIdGeocode(response.result);
            if (crossCheckIpDistance) {
                setDistanceBetweenStr(crossCheckIpDistance);
            }
            else if (ipGeocode) {
                setDistanceBetweenStr(distanceBetweenGoogleLatLong(response.result, ipGeocode).toFixed(2));
            }
        }, console.error);
    }, []);
    return (React.createElement(Dropdown, { title: "Location" },
        React.createElement(Box, null,
            React.createElement(LocationCaption, null),
            React.createElement(Box, { display: "grid", marginBottom: "spacing.default", style: {
                    gridTemplateColumns: 'auto 1fr',
                    justifyItems: 'start',
                    gridGap: '10px'
                } },
                React.createElement(Text, { style: { fontWeight: 'bold' } }, `ID Address: `),
                React.createElement(Text, { "data-ph-mask": true }, idAddressStr || 'N/A'),
                React.createElement(Text, { style: { fontWeight: 'bold' } }, `IP Address: `),
                React.createElement(Text, { "data-ph-mask": true }, ipAddressStr || 'N/A'),
                React.createElement(Text, { style: { fontWeight: 'bold' } }, `Distance Between: `),
                React.createElement(Text, null, distanceBetweenStr ? `${distanceBetweenStr} Miles` : `N/A`)),
            React.createElement(LocationMap, { idGeocode: idGeocode, ipGeocode: ipGeocode }))));
};
